if (!customElements.get('sv-oddit-product-video')) {
  customElements.define('sv-oddit-product-video', class extends HTMLElement {
    connectedCallback() {
      const frame = this.querySelector('.sv-oddit-product-video__frame');
      if (!this.initialMarkup && frame) this.initialMarkup = frame.innerHTML;
      this.bindPlayer();
    }

    bindPlayer() {
      this.playButton = this.querySelector('[data-sv-oddit-product-video-play]');
      this.template = this.querySelector('[data-sv-oddit-product-video-template]');
      if (!this.playButton || !this.template) return;

      this.playButton.addEventListener('click', () => this.play());
    }

    play() {
      if (this.hasAttribute('data-playing')) return;
      const frame = this.querySelector('.sv-oddit-product-video__frame');
      const media = this.template.content.cloneNode(true);
      this.setAttribute('data-playing', '');
      this.playButton.remove();
      frame.appendChild(media);
    }

    stop() {
      if (!this.hasAttribute('data-playing')) return;
      const frame = this.querySelector('.sv-oddit-product-video__frame');
      if (!frame || !this.initialMarkup) return;
      frame.innerHTML = this.initialMarkup;
      this.removeAttribute('data-playing');
      this.bindPlayer();
    }
  });
}
